// extracted by mini-css-extract-plugin
module.exports = {"quizStep":"QuizStep_quizStep__3RY3J","quizStepWrapper":"QuizStep_quizStepWrapper__LdE_R","quizStepContent":"QuizStep_quizStepContent__qIBgR"};